import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import styled from "styled-components";

import "./App.css";

import Header from "./components/molecules/header";
import Footer from "./components/molecules/footer";

import ScrollToTop from "./components/ScrollToTop";

import StartPage from "./components/pages/StartPage";
import AboutPage from "./components/pages/AboutPage";
import AlleImmosPage from "./components/pages/AlleImmosPage";
import PropertyPage from "./components/pages/PropertyPage";

import Datenschutz from "./components/pages/Datenschutz";
import Impressum from "./components/pages/Impressum";
import Widerruf from "./components/pages/Widerruf";

const Body = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
`;

function App() {
    return (
        <Router>
            <ScrollToTop /> {/* 👈 HERE */}

            <Header />

            <Body>
                <Routes>
                    <Route path="/" element={<StartPage />} />
                    <Route path="/about" element={<AboutPage />} />
                    <Route path="/immobilien" element={<AlleImmosPage />} />
                    <Route path="/immobilie/:id" element={<PropertyPage />} />
                    <Route path="/datenschutz" element={<Datenschutz />} />
                    <Route path="/impressum" element={<Impressum />} />
                    <Route path="/widerruf" element={<Widerruf />} />
                </Routes>
            </Body>

            <Footer />
        </Router>
    );
}

export default App;